module.exports = __webpack_public_path__ + "img/about-img.ac168849.jpg";